import React from "react";
import { Col, Row } from "antd";

import DownloadBtn from "../DownloadBtn";
import ImageFile from "../ImageFile";
import PdfFile from "../PdfFile";
import "./style.less";

const DriverDocuments = ({ driver }) => {
  const extension = (url) => {
    return url?.split(".").pop().toLowerCase();
  };

  const file = (url) => {
    if (!url) return null;
    
    if (extension(url) !== "pdf") {
      return <ImageFile url={url} />;
    }
    return <PdfFile url={url} />;
  };

  // Safe helper to check if document exists
  const hasDoc = (docField) => {
    if (!docField) return false;
    if (Array.isArray(docField)) return docField.length > 0;
    return true;
  };

  // Get all documents as array
  const getDocsArray = (docField) => {
    if (!docField) return [];
    if (Array.isArray(docField)) return docField;
    return [docField];
  };

  return (
    <>
      {driver.documents && (
        <Row>
          Documents:
          
          {/* Car Registration - No Change */}
          {driver.documents.carRegistrationDocuments && (
            <Col span={24}>
              <strong>Car Registration Documents:</strong>
              <div className="documentWrapper">
                {file(driver.documents.carRegistrationDocuments.url)}
                <DownloadBtn path={driver.documents.carRegistrationDocuments.url} />
              </div>
            </Col>
          )}

          {/* Driving License - Now supports arrays */}
          {hasDoc(driver.documents.drivingLicense) && (
            <Col span={24}>
              <strong>Driving License:</strong>
              
              {getDocsArray(driver.documents.drivingLicense).map((doc, index) => (
                <div key={doc.id || index} className="documentWrapper" style={{ marginTop: index > 0 ? '16px' : '0' }}>
                  {doc.side && <div><em>{doc.side.charAt(0).toUpperCase() + doc.side.slice(1)}:</em></div>}
                  {file(doc.url)}
                  <DownloadBtn path={doc.url} />
                </div>
              ))}
            </Col>
          )}

          {/* National ID - Now supports arrays */}
          {hasDoc(driver.documents.nationalId) && (
            <Col span={24}>
              <strong>National Id:</strong>
              
              {getDocsArray(driver.documents.nationalId).map((doc, index) => (
                <div key={doc.id || index} className="documentWrapper" style={{ marginTop: index > 0 ? '16px' : '0' }}>
                  {doc.side && <div><em>{doc.side.charAt(0).toUpperCase() + doc.side.slice(1)}:</em></div>}
                  {file(doc.url)}
                  <DownloadBtn path={doc.url} />
                </div>
              ))}
            </Col>
          )}

          {/* Police Clearance - No Change */}
          {driver.documents.policeClearanceCertificate && (
            <Col span={24}>
              <strong>Police Clearance Certificate:</strong>
              <div className="documentWrapper">
                {file(driver.documents.policeClearanceCertificate.url)}
                <DownloadBtn path={driver.documents.policeClearanceCertificate.url} />
              </div>
            </Col>
          )}
        </Row>
      )}
    </>
  );
};

export default DriverDocuments;